import { StyleProp, ViewStyle } from 'react-native';
import Svg, { ClipPath, Defs, G, Mask, Path, Rect } from 'react-native-svg';
import { nativewindWrapSvg } from './wrapSvg';

function FlagIconRaw({
  style,
  fill,
  width,
}: {
  style?: StyleProp<ViewStyle>;
  fill?: string;
  className?: string;
  width?: number;
}) {
  return (
    <Svg
      width={width ?? 25}
      height={width ?? 24}
      viewBox="0 0 25 24"
      fill={fill}
      style={style}
    >
      <G clipPath="url(#clip0_16714_57867)">
        <Mask
          id="mask0_16714_57867"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="25"
          height="24"
        >
          <Path d="M0.125 0H24.1257V23.9995H0.125V0Z" fill="white" />
        </Mask>
        <G mask="url(#mask0_16714_57867)">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.124609 19.1154V4.8938L8.06624 12.0046L0.121094 19.1154H0.124609Z"
            fill="black"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.54297 24.0043L14.4584 16.0076H27.1214V23.9996H5.54297V24.0043Z"
            fill="#0000CC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.97266 9.68548e-05H27.1206V8.00618H14.4541C14.4541 8.00618 5.08867 -0.0795889 4.97266 9.68548e-05Z"
            fill="#FF0000"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.124609 3V4.89371L8.06624 11.9998L0.121094 19.1153V21.0043L10.1228 12.0045L0.121094 3H0.124609Z"
            fill="#FFCC00"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.125 2.99994V0H3.46477L14.0536 9.5623H27.1244V14.4466H14.0536L3.46126 23.9995H0.125V21.0042L10.1232 12.0044L0.128515 2.99994H0.125Z"
            fill="#009933"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.46094 0H5.54214L14.4576 8.00139H27.1206V9.5623H14.0533L3.46094 0.0046874V0ZM3.46094 24.0042H5.54214L14.4576 16.0075H27.1206V14.4513H14.0533L3.46094 23.9995V24.0042Z"
            fill="white"
          />
        </G>
      </G>
      <Defs>
        <ClipPath id="clip0_16714_57867">
          <Rect x="0.125" width="24" height="24" rx="12" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export const FlagIcon = nativewindWrapSvg(FlagIconRaw);
